(() => {
	angular.module('main').controller('AdminController', AdminController);

	AdminController.$inject = [
		'$scope',
		'$q',
		'$filter',
		'$rootScope',
		'adminReportsDataService',
		'adminUsersDataService',
		'ambassadorService',
		'ambassadorsDataService',
		'validationService',
		'messageService',
		'paginationService'
	];

	function AdminController(
		$scope,
		$q,
		$filter,
		$rootScope,
		adminReportsDataService,
		adminUsersDataService,
		ambassadorService,
		ambassadorsDataService,
		validationService,
		messageService,
		paginationService
	) {
		document.title = 'Studio Ninja | Super Admin';
		$scope.usersData = null;
		$scope.filteredAdminTableData = null;
		$scope.reportTypes = [
			'New sign ups',
			'New paying members',
			'Total free members',
			'Total paying members',
			'Total revenue',
			'New cancellations'
		];
		$scope.selectedReportType = $scope.reportTypes[3];

		$scope.newSignUpsReport = null;
		$scope.newPayingMembersReport = null;
		$scope.newCancellationsReport = null;
		$scope.totalRevenueReport = null;
		$scope.synchronization = false;

		$scope.users = [];
		$scope.totalItems = 0;
		$scope.pageRequest = {
			filterBy: null,
			paging: {
				pageSize: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageNumber: 0,
				searchToken: null
			},
			sortCriteria: {
				fieldName: 'id',
				sortAscending: false
			}
		};

		let chart;

		$scope.changeReportType = function() {
			switch ($scope.selectedReportType) {
				case $scope.reportTypes[0]:
					buildNewSignUpsReport();
					break;
				case $scope.reportTypes[1]:
					buildNewPayingMembersReport();
					break;
				case $scope.reportTypes[2]:
					buildTotalFreeMembersReport();
					break;
				case $scope.reportTypes[3]:
					buildTotalPayingMembersReport();
					break;
				case $scope.reportTypes[4]:
					buildTotalRevenueReport();
					break;
				case $scope.reportTypes[5]:
					buildNewCancellationsReport();
					break;
				default:
					break;
			}
		};

		// navigation
		$scope.searchRequest = search => {
			$scope.pageRequest.filterBy = search || null;
			$scope.pageRequest.paging.pageNumber = 0;
			getResultsPage(
				$scope.pageRequest.paging.pageNumber,
				$scope.pageRequest.paging.pageSize
			);
		};

		$scope.order = function(predicate) {
			$scope.pageRequest.sortCriteria.sortAscending =
				$scope.pageRequest.sortCriteria.fieldName === predicate
					? !$scope.pageRequest.sortCriteria.sortAscending
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.sortCriteria.sortAscending
			);
		};

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			const newPageRequest = paginationService.getResultsPage(
				$scope.pageRequest,
				$scope.totalItems,
				pageNumber,
				perPage,
				predicate,
				reverse
			);

			if (newPageRequest) {
				$scope.getAdminTableData(newPageRequest);
			}
		}

		$scope.$watch('$viewContentLoaded', () => {
			getResultsPage(
				$scope.pageRequest.paging.pageNumber,
				$scope.pageRequest.paging.pageSize
			);
		});

		$scope.getAdminTableData = pageRequest => {
			$scope.pageRequest = pageRequest;
			$rootScope.paginationPerPage = pageRequest.paging.pageSize;
			adminUsersDataService.getUsers(pageRequest).subscribe(
				data => successGetAdminTableData(data),
				err => {
					$scope.synchronization = false;
					messageService.showDefaultErrorMessage(err);
				}
			);
		};

		function successGetAdminTableData(data) {
			$scope.totalItems = data ? data.totalSize : 0;
			$scope.pageNumbers = paginationService.calculatePageNumbers(
				$scope.totalItems,
				$scope.pageRequest.paging.pageSize
			);

			$scope.changeReportType();
			$scope.usersData = data.items;
			$scope.newSignUpsReport = $scope.newSignUpsReport || null;
			$scope.newPayingMembersReport = $scope.newPayingMembersReport || null;
			$scope.newCancellationsReport = $scope.newCancellationsReport || null;
			$scope.totalRevenueReport = $scope.totalRevenueReport || null;
			$scope.synchronization = false;
			$scope.pageRequest.paging.searchToken = data.searchToken;
			parseDate();
		}

		function buildNewSignUpsReport() {
			if (!$scope.newSignUpsReport) {
				adminReportsDataService
					.getSignUpReport()
					.subscribe(data => {
						$scope.newSignUpsReport = data;
						drawChart(generateSeries($scope.newSignUpsReport));
					})
					.catch(messageService.showDefaultErrorMessage);
			} else {
				drawChart(generateSeries($scope.newSignUpsReport));
			}
		}

		function buildNewPayingMembersReport() {
			if (!$scope.newPayingMembersReport) {
				adminReportsDataService
					.getPayingMembersReport()
					.catch(messageService.showDefaultErrorMessage)
					.subscribe(data => {
						$scope.newPayingMembersReport = data;
						drawChart(generateSeries($scope.newPayingMembersReport));
					});
			} else {
				drawChart(generateSeries($scope.newPayingMembersReport));
			}
		}

		function buildTotalFreeMembersReport() {
			if (
				!$scope.newSignUpsReport ||
				!$scope.newPayingMembersReport ||
				!$scope.newCancellationsReport
			) {
				adminReportsDataService
					.getSignUpReport()
					.flatMap(data => {
						$scope.newSignUpsReport = data;
						return adminReportsDataService.getPayingMembersReport();
					})
					.flatMap(data => {
						$scope.newPayingMembersReport = data;
						return adminReportsDataService.getCancellationReport();
					})
					.catch(err => messageService.showDefaultErrorMessage(err))
					.subscribe(data => {
						$scope.newCancellationsReport = data;
						const totalMembersReport = generateSequentiallySummedReport(
							$scope.newSignUpsReport
						);
						const totalPayingMembersReport = generateSequentiallySummedReport(
							$scope.newPayingMembersReport
						);
						const totalCancellationsMembersReport = generateSequentiallySummedReport(
							$scope.newCancellationsReport
						);
						const totalFreeMembersReport = correspondinglyAddReports(
							correspondinglySubtractReports(
								totalMembersReport,
								totalPayingMembersReport
							),
							totalCancellationsMembersReport
						);
						drawChart(generateSeries(totalFreeMembersReport));
					});
			} else {
				const totalMembersReport = generateSequentiallySummedReport(
					$scope.newSignUpsReport
				);
				const totalPayingMembersReport = generateSequentiallySummedReport(
					$scope.newPayingMembersReport
				);
				const totalCancellationsMembersReport = generateSequentiallySummedReport(
					$scope.newCancellationsReport
				);
				const totalFreeMembersReport = correspondinglyAddReports(
					correspondinglySubtractReports(
						totalMembersReport,
						totalPayingMembersReport
					),
					totalCancellationsMembersReport
				);
				drawChart(generateSeries(totalFreeMembersReport));
			}
		}

		function buildTotalPayingMembersReport() {
			if (!$scope.newPayingMembersReport || !$scope.newCancellationsReport) {
				adminReportsDataService
					.getPayingMembersReport()
					.catch(messageService.showDefaultErrorMessage)
					.flatMap(data => {
						$scope.newPayingMembersReport = data;
						return adminReportsDataService.getCancellationReport();
					})
					.subscribe(data => {
						$scope.newCancellationsReport = data;
						const totalPayingMembersReport = generateSequentiallySummedReport(
							$scope.newPayingMembersReport
						);
						const totalCancellationsMembersReport = generateSequentiallySummedReport(
							$scope.newCancellationsReport
						);
						const resultPayingMembersReport = correspondinglySubtractReports(
							totalPayingMembersReport,
							totalCancellationsMembersReport
						);
						drawChart(generateSeries(resultPayingMembersReport));
					});
			} else {
				const totalPayingMembersReport = generateSequentiallySummedReport(
					$scope.newPayingMembersReport
				);
				const totalCancellationsMembersReport = generateSequentiallySummedReport(
					$scope.newCancellationsReport
				);
				const resultPayingMembersReport = correspondinglySubtractReports(
					totalPayingMembersReport,
					totalCancellationsMembersReport
				);
				drawChart(generateSeries(resultPayingMembersReport));
			}
		}

		function buildTotalRevenueReport() {
			if (!$scope.totalRevenueReport) {
				adminReportsDataService
					.getTotalRevenueReport()
					.catch(messageService.showDefaultErrorMessage)
					.subscribe(data => {
						$scope.totalRevenueReport = data;
						drawChart(generateSeries($scope.totalRevenueReport));
					});
			} else {
				drawChart(generateSeries($scope.totalRevenueReport));
			}
		}

		function buildNewCancellationsReport() {
			if (!$scope.newCancellationsReport) {
				adminReportsDataService
					.getCancellationReport()
					.catch(messageService.showDefaultErrorMessage)
					.subscribe(result => {
						$scope.newCancellationsReport = result.data;
						drawChart(generateSeries($scope.newCancellationsReport));
					});
			} else {
				drawChart(generateSeries($scope.newCancellationsReport));
			}
		}

		function drawChart(series) {
			chart = Highcharts.chart('report-container', {
				chart: {
					type: 'areaspline'
				},
				title: {
					text: ''
				},
				legend: {
					backgroundColor:
						(Highcharts.theme && Highcharts.theme.legendBackgroundColor) ||
						'#FFFFFF'
				},
				xAxis: {
					categories: [
						'Jan',
						'Feb',
						'Mar',
						'Apr',
						'May',
						'Jun',
						'Jul',
						'Aug',
						'Sep',
						'Oct',
						'Nov',
						'Dec'
					],
					plotBands: [
						{
							// visualize the weekend
							from: 0,
							to: 0,
							color: 'rgba(68, 170, 213, .2)'
						}
					]
				},
				yAxis: {
					min: 0,
					title: {
						text: ''
					}
				},
				tooltip: {
					shared: true
				},
				credits: {
					enabled: false
				},
				plotOptions: {
					areaspline: {
						fillOpacity: 0.1
					}
				},
				series
			});
		}

		function generateSeries(report) {
			const series = [];
			let seriesEntry = null;
			for (let i = 0; i < report.length; i++) {
				if (i % 12 === 0) {
					seriesEntry = {};
					seriesEntry.name = report[i].year;
					seriesEntry.data = [];
				}
				seriesEntry.data.push(report[i].value);
				if ((i + 1) % 12 === 0) {
					series.push(seriesEntry);
				}
			}
			return series;
		}

		function generateSequentiallySummedReport(report) {
			const reportCopy = angular.copy(report);
			let sum = 0;
			for (let i = 0; i < reportCopy.length; i++) {
				sum += reportCopy[i].value;
				reportCopy[i].value = sum;
			}
			return reportCopy;
		}

		function correspondinglySubtractReports(minuend, subtrahend) {
			const minuendCopy = angular.copy(minuend);
			for (let i = 0; i < subtrahend.length; i++) {
				for (let j = 0; j < minuendCopy.length; j++) {
					if (
						minuendCopy[j].month === subtrahend[i].month &&
						minuendCopy[j].year === subtrahend[i].year
					) {
						minuendCopy[j].value -= subtrahend[i].value;
						break;
					}
				}
			}
			return minuendCopy;
		}

		function correspondinglyAddReports(firstReport, secondReport) {
			const addedCopy = angular.copy(firstReport);
			for (let i = 0; i < secondReport.length; i++) {
				for (let j = 0; j < addedCopy.length; j++) {
					if (
						addedCopy[j].month === secondReport[i].month &&
						addedCopy[j].year === secondReport[i].year
					) {
						addedCopy[j].value += secondReport[i].value;
						break;
					}
				}
			}
			return addedCopy;
		}

		$scope.deleteModal = function(user) {
			$scope.deleteUser = user;
			$('#deleteModal').modal('show');
		};

		$scope.deleteRequest = function(email) {
			adminUsersDataService.deleteUser(email).subscribe(
				() => {
					$('#deleteModal').modal('hide');
					delete $scope.deleteUser;
					toastr.success('User has been deleted');
					$scope.usersData = deleteItemByEmail($scope.usersData, email);
					getResultsPage(
						$scope.pageRequest.paging.pageNumber,
						$scope.pageRequest.paging.pageSize
					);
				},
				err => {
					messageService.showDefaultErrorMessage(err);
				}
			);
		};

		function deleteItemByEmail(array, email) {
			return array.filter(item => item.email && item.email !== email);
		}

		function parseDate() {
			const dateFormat = 'd MMMM yyyy';

			$scope.usersData.forEach(item => {
				item.registeredAt = $filter('date')(item.registeredAt, dateFormat);
				item.lastLogin = $filter('date')(item.lastLogin, dateFormat);
			});
		}

		$scope.synchronize = function() {
			$scope.synchronization = true;
			adminUsersDataService
				.synchronize()
				.catch(messageService.showDefaultErrorMessage)
				.finally(() => ($scope.synchronization = false))
				.subscribe(data => {
					if (data && data.errorMessage) {
						messageService.showDefaultErrorMessage(data.errorMessage);
					}
				});
		};

		$scope.showSubscriptionModal = function(user) {
			adminUsersDataService
				.getUserSubscription(user.email)
				.subscribe(
					data => successGetUserInfo(data, user),
					err => messageService.showDefaultErrorMessage(err)
				);
		};

		function successGetUserInfo(data, user) {
			if (data.errorMessage) {
				return $q.reject(data);
			}
			$scope.userInfo = data;
			$scope.userInfoLocal = user;
			if ($scope.userInfo.championForever) {
				$scope.userInfo.championTime = 'Champion forever!';
			}
			if ($scope.userInfoLocal.ambassador) {
				$scope.userInfo.isAmbassador = true;
			}
			$('#subscriptionModal').modal('show');
		}

		$scope.submitAmbassadorCode = ambassador => {
			$scope.btn_disable = true;
			const isExistedAmbassador = ambassador.isAmbassador;
			const ambassador2save = ambassadorService.validateAmbassador(ambassador);

			if (!ambassador2save) {
				$scope.btn_disable = false;
				return;
			}

			let action;
			if (isExistedAmbassador) {
				action = ambassadorsDataService.updateAmbassador(ambassador2save);
			} else {
				action = ambassadorsDataService.createAmbassador(ambassador2save);
			}

			action
				.then(() => {
					$('#addAmbassadorCodeModal').modal('hide');
					toastr.success('Ambassador saved', 'Success!');
					getResultsPage(
						$scope.pageRequest.paging.pageNumber,
						$scope.pageRequest.paging.pageSize
					);
				})
				.catch(messageService.showDefaultErrorMessage)
				.finally(() => {
					$scope.btn_disable = false;
				});
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/admin/adminControllers.js